module.exports = __webpack_public_path__ + "img/ANEGapDetailed-min.88e64c65.png";